import styled from 'styled-components'
import Container from './Container'

const Page = styled(Container)`
  padding: 24px;
`

export default Page
